import React, { useState, useRef, ChangeEvent, useEffect } from "react";
import { InputComponent } from "../../../core/Forms/InputComponent";
// import PhoneInput, { formatPhoneNumber } from 'react-phone-number-input';
import * as UI from "../../../common";
import { validateProfileForm } from "../../../../modules/profile";
import { SidebarDrawer } from "../../../common/SidebarDrawer";
import { DropdownComponent } from "../../../core/Forms/DropdownComponent";
import { ICreateProfile, IUpdateProfile } from "../../../../@types/profile";
import { INDUSTRIES, SIZES } from "../../../../constants/industries";
import { clearFieldError } from "../../../../utils/handleErrors";
import LocationSelector from "../../../common/Address";
import { shortenFileName } from "../../../../utils";
import { CloseIcon } from "../../../../assets/icons";
import UploadIcon from "../../../../assets/icons/UploadIcon";
import PhoneInputComponent from "../../../common/PhoneInputComponent";
import { useTranslation } from "react-i18next";
import { useCompanyStore } from "../../../../state/useCompanyStore";
import { useUserStore } from "../../../../state";
import { showToast } from "../../../../utils/toastUtils";

interface EditProfileProps {
  show: boolean;
  onSubmit: (profile: IUpdateProfile) => Promise<JSX.Element | void>;
  onClick?: (e?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  isLoading: boolean;
  onClose?: () => void;
  data: FormData;
}

interface FormData {
  firstName: string;
  lastName: string;
  businessName: string;
  industry: string;
  phone: string;
  email?: string;
  address: string;
  state: string;
  city: string;
  businessSize: string;
  brandColor: string;
  code: string;
  logoBase64: string;
  isVerified: boolean;
}
const MAX_FILE_SIZE_KB = 100;

const EditProfile = ({
  show,
  onSubmit,
  onClose,
  data,
  isLoading,
}: EditProfileProps) => {
  const { t } = useTranslation("settings");
  const [formData, setFormData] = React.useState<FormData>({
    firstName: data.firstName,
    lastName: data.lastName,
    businessName: data.businessName,
    industry: data.industry,
    phone: data.phone,
    address: data.address,
    state: data.state,
    city: data.city,
    code: data.code,
    businessSize: data.businessSize,
    brandColor: data.brandColor,
    logoBase64: data.logoBase64,
    isVerified: data.isVerified,
  });

 

useEffect(() => {
    if (data) {
        setFormData({
            firstName: data.firstName || "",
            lastName: data.lastName || "",
            businessName: data.businessName || "",
            industry: data.industry || "",
            phone: data.phone || "",
            address: data.address || "",
            state: data.state || "",
            city: data.city || "",
            code: data.code || "",
            businessSize: data.businessSize || "",
            brandColor: data.brandColor || "",
            logoBase64: data.logoBase64 || "",
            isVerified: data.isVerified || false,
        });
    }
}, [data]);

  const [selectedValue, setSelectedValue] = useState(data.industry);
  const inputRef = React.useRef<HTMLInputElement>(null);
  const [selectedValue2, setSelectedValue2] = useState(data.businessSize);
  const [state, setState] = React.useState(data?.state || "");
  const [city, setCity] = React.useState(data?.city || "");
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  // Store email separately
  const [file, setFile] = React.useState<File | null>();
  const [fileName, setFileName] = React.useState<string>("");
  const [error, setError] = React.useState<string>();
  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
    //  setEditedData({ ...editedData, [name]: value });
  };

    const user = useUserStore((state) => state.user);
    const userStore = useCompanyStore();
  const [isLoggedIn, setIsLoggedIn] = React.useState<boolean>(!!user);

  const userData = userStore.company; 

   // Fetch email from the store
   const [email, setEmail] = React.useState<string>(userData?.email || "");

   const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (isSubmitting) return; // Prevent multiple submissions

  setIsSubmitting(true);
  
    const { email, ...formDataWithoutEmail } = formData;
  
    const validationResults = validateProfileForm(formDataWithoutEmail);
  
    if (Object.keys(validationResults).length === 0) {
      onSubmit(formDataWithoutEmail);
    } else {
      showToast("Please fill in the required fields.", "error")
    }
    setIsSubmitting(false);
  };

  // Update login status
  React.useEffect(() => {
    setIsLoggedIn(!!user);
    setEmail(userStore.company?.email || "");
  }, [user, userStore.company?.email]);

  const dropDownArray = INDUSTRIES;
  const dropDownArray2 = SIZES;
  const handleDropDownChange = (name: string, selectedValue: string) => {
    setFormData({ ...formData, industry: selectedValue });
  };

  const handleDropDownChange2 = (name: string, selectedValue2: string) => {
    setFormData({ ...formData, businessSize: selectedValue2 });
  };

  const handleLocationChange = (
    selectedState: string,
    cities: string | any[]
  ) => {
    setState(selectedState);
    setCity(cities.length > 0 ? cities[0] : "");

    setFormData((prevData) => ({
      ...prevData,
      state: selectedState,
      city: cities.length > 0 ? cities[0] : "",
    }));
  };

  const validationResults = validateProfileForm(formData);
  const handleSelectFile = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    inputRef.current?.click();
  };

  const handleUpload = (e: ChangeEvent<HTMLInputElement>) => {
    const selectedFile = e.target.files ? e.target.files[0] : null;
    if (selectedFile) {
      const fileSizeInKB = selectedFile.size / 1024;
      if (fileSizeInKB > MAX_FILE_SIZE_KB) {
        setError(`File size should not exceed ${MAX_FILE_SIZE_KB} KB`);
        setFile(null);
        setFileName("");
        return;
      }

      const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
      if (!allowedTypes.includes(selectedFile.type)) {
        setError("Please upload a PNG, or JPG");
        setFile(null);
        setFileName("");
        return;
      }

      const reader = new FileReader();
      reader.onload = (event) => {
        if (event.target && typeof event.target.result === "string") {
          const result = event.target.result as string;
          setFormData((prevData) => ({
            ...prevData,
            brandLogo: result,
          }));
        }
      };
      reader.onerror = (event) => {
        console.error("Error reading the file", event.target?.error);
      };
      reader.readAsDataURL(selectedFile);

      setFile(selectedFile);
      setFileName(selectedFile.name);
      setError(undefined);
    }
  };
  const handlePhoneNumberChange = (phone: any) => {
    setFormData({ ...formData, phone: phone || "" });
  };

  return (
    <form onSubmit={handleFormSubmit}>
      <div className="flex flex-col i">
        <div className="flex flex-col  md:flex-row gap-[16px] md:gap-[14px] mb-[16px] md:mb-[16px]">
          <div className="flex flex-col md:flex-row md:gap-[3em] gap-[1em] w-full">
            <div className="">
              <h1 className="font-semibold">Personal info</h1>
              <p className="xl:w-[400px] text-[14px] text-gray-600">Update your personal information here</p>
            </div>

            <div className="flex flex-col w-full">
            <div className="flex flex-col md:flex-row md:gap-[1.4em]  w-full">
            <div className="flex flex-col">
            <label
              htmlFor="first-name"
              className="text-[14px] font-medium "
            >
              {t("Settings.firstname")} <span className="text-red-600">*</span>
            </label>
            <div className="">
              <InputComponent
                name="firstName"
                value={formData.firstName}
                className="border bg-[#F2F2F2] placeholder:text-[1rem] placeholder:text-[#98A2B3] placeholder:font-normal w-full  md:w-[210px] h-[48px] border-gray-300 rounded lg:w-[275px]"
                type="text"
                placeholder="First name"
                handleChange={handleInputChange}
              />
              {validationResults.firstName && (
                <p
                  className="error"
                  id="firstName-error"
                  style={{ color: "red" }}
                >
                  {validationResults.firstName}
                </p>
              )}
            </div>
            </div>
              
            <div className="flex flex-col mt-2 md:mt-0 lg:mt-0 xl:mt-0">
            <label
              htmlFor="last-name"
              className="text-[14px] font-medium  "
            >
              {t("Settings.lastname")} <span className="text-red-600">*</span>
            </label>
            <div className="">
              <InputComponent
                name="lastName"
                className="border bg-[#F2F2F2] placeholder:text-[1rem] placeholder:text-[#98A2B3]  placeholder:font-normal h-[48px] w-full border-gray-300  rounded md:w-[210px] lg:w-[275px]"
                type="text"
                placeholder="Last name"
                value={formData.lastName}
                handleChange={handleInputChange}
              />
              {validationResults.lastName && (
                <p
                  className="error"
                  id="lastName-error"
                  style={{ color: "red" }}
                >
                  {validationResults.lastName}
                </p>
              )}
            </div>
          </div>
          </div>
          
         
            
          <div className="flex flex-col md:flex-row md:gap-[1.4em]">
          <div className="flex flex-col  mb-[14px] mt-3">
          <label
            htmlFor="email"
            className="text-[14px] font-medium  "
          >
            {t("Settings.email")} address <span className="text-red-600">*</span>
          </label>
          <div className="">
            <InputComponent
              name="email"
              className="border  placeholder:text-[1rem] placeholder:text-[#98A2B3] placeholder:font-normal h-[48px] bg-[#F2F2F2] border-gray-300 rounded  w-full md:w-[210px] lg:w-[275px]"
              type="text"
              placeholder="Enter email"
              value={email} 
              handleChange={handleInputChange}
              disabled
              readonly 
            />
            
          </div>
          </div>

          <div className="flex flex-col mb-[] md:mt-3">
            <label htmlFor="phone" className="text-[14px]  font-normal">
              Phone Number <span className="text-red-600">*</span>
            </label>
                 <PhoneInputComponent
                    onPhoneNumberChange={handlePhoneNumberChange}
                    
                    inputClass="text-[#00000]"
                    containerClass="setting_edit"
                    value={formData.phone}
                  />

            {validationResults.phone && (
              <p className="error text-[16px]" id="phone-error" style={{ color: 'red' }}>
                {validationResults.phone}
              </p>
            )}
          </div>
        </div>
        </div>
        </div>
        </div>
        </div>

        <hr className="my-6 md:hidden" />

        <div className="flex flex-col md:flex-row md:gap-[3em] gap-[1em]  md:mt-[2em] w-full">
        <div className="">
              <h1 className="font-semibold">Business info</h1>
              <p className="xl:w-[400px] lg:w-[200px] md:w-[140px] text-[14px] text-gray-600">Update your business information here</p>
            </div>

         <div className="flex flex-col"> 
        <div className="flex flex-col md:flex-row md:gap-[1.4em]  xl:w-full">    
        <div className="">
     
          <div className="flex flex-col mb-[] mt-2">
            <label
              htmlFor="code"
              className="text-[14px] font-medium"
            >
              Registration Code <span className="text-red-600">*</span>
            </label>
            <div>
              <InputComponent
                name="code"
                className="border bg-[#F2F2F2] placeholder:text-[1rem] placeholder:text-[#98A2B3] placeholder:font-normal h-[48px] rounded border-gray-300 w-full  md:w-[210px] lg:w-[275px]"
                type="text"
                value={formData.code}
                handleChange={handleInputChange}
                placeholder="Business Registration Code"
              />
              {validationResults.businessName && (
                <p className="error" id="name-error" style={{ color: "red" }}>
                  {validationResults.businessName}
                </p>
              )}
            </div>
          </div>
        </div>
        
        <div>
             <div className="flex flex-col mb-[]  ">
          <label
            htmlFor="industry"
            className="text-[14px]  font-medium mt-[1em]"
          >
            {t("Settings.category")} <span className="text-red-600">*</span>
          </label>
          <div className="">
            <DropdownComponent
              options={INDUSTRIES}
              placeholder="Select category"
              selectedValue={selectedValue}
              setSelectedValue={setSelectedValue}
              onChange={handleDropDownChange}
              className="border bg-[#F2F2F2] placeholder:text-[1rem] placeholder:text-[#98A2B3] placeholder:font-normal h-[48px] border-gray-300   w-[210px] lg:w-[275px] rounded "
              iconClassName="ml-[-2em] mt-[4px]"
              dropdownClassName=" w-[280px] border-gray-300 rounded-md placeholder-gray-400 placeholder-opacity-75 md:w-[210px] lg:w-[275px]  bg-white  rounded py-1 focus:ring-0 pointer-events placeholder-gray-400 placeholder-opacity-75"
              enableSearch={true}
            />
          </div>
        </div>
        </div>
        </div>

        <div className="flex flex-col md:flex-row md:gap-[1.4em]">
       
        <div className="flex flex-col mb-[] mt-4">
            <label
              htmlFor="business-name"
              className="text-[14px]  font-medium"
            >
              Business Name <span className="text-red-600">*</span>
            </label>
            <div className="">
              <InputComponent
                name="businessName"
                className="border bg-[#F2F2F2] placeholder:text-[1rem] placeholder:text-[#98A2B3] border-gray-300 placeholder:font-normal h-[48px] rounded w-full  md:w-[210px] lg:w-[275px]"
                type="text"
                value={formData.businessName}
                handleChange={handleInputChange}
                placeholder="Business Name"
              />
              {validationResults.businessName && (
                <p className="error" id="name-error" style={{ color: "red" }}>
                  {validationResults.businessName}
                </p>
              )}
            </div>
          </div>

        {/* <div className="flex flex-col mb-[] mt-2 ">
          <label
            htmlFor="industry"
            className="text-[12px] text-[#666666] font-normal mt-[1em]"
          >
            Business Size
          </label>
          <div className="">
            <DropdownComponent
              options={SIZES}
              placeholder="Select Business Size"
              selectedValue={selectedValue2}
              setSelectedValue={setSelectedValue2}
              onChange={handleDropDownChange2}
              className="border bg-[#F2F2F2] placeholder:text-[1rem] placeholder:text-[#000000] placeholder:font-normal h-[48px]  w-[280px] rounded "
              iconClassName="ml-[-2em] mt-[4px]"
              dropdownClassName=" w-[280px] border-gray-300 rounded-md placeholder-gray-400 placeholder-opacity-75 md:w-[210px]   bg-white  rounded py-1 focus:ring-0 pointer-events placeholder-gray-400 placeholder-opacity-75"
            />
          </div>
        </div> */}
             <div className="flex flex-col mb-[] mt-2">
          <label
            htmlFor="address"
            className="text-[14px]  font-medium mt-3 pl-[px]"
          >
            {t("Settings.address")} <span className="text-red-600">*</span>
          </label>
          <div className="flex flex-col ">
            <div className="">
              <InputComponent
                name="address"
                className="border bg-[#F2F2F2] placeholder:text-[1rem] placeholder:text-[#98A2B3] border-gray-300 placeholder:font-normal h-[48px]  w-full md:w-[210px] lg:w-[275px] rounded"
                type="text"
                value={formData.address}
                handleChange={handleInputChange}
                placeholder="Enter business address"
              />
            </div>
          </div>
        </div>
        </div>

        <div className="flex flex-col ">
          <div className=" mt-2 lg:mt-[1em]  biglg:mt-[1em] ">
            <LocationSelector
              onLocationChange={handleLocationChange}
              onError={(error: any) => {}}
              selectedState={state}
              selectedCity={city}
            />
          </div>
        </div>
        </div>
        </div>


       
    
        {/* <div className="flex flex-col  mb-[14px] mt-3">
          <label
            htmlFor="email"
            className="text-[12px] text-[#666666] font-normal"
          >
            {t("Settings.email")}
          </label>
          <div className="max-w-[350px] md:min-w-[434px]">
            <InputComponent
              name="email"
              className="border  placeholder:text-[1rem] placeholder:text-[#000000] placeholder:font-normal h-[48px] bg-[#F2F2F2] rounded  w-[280px] max-w-[350px] md:min-w-[434px]"
              type="text"
              placeholder="Kelz4U@primaboost.com"
              value={formData.email}
              disabled
            />
            {validationResults.email && (
              <p
                className="error"
                id="email-error ml-[4em]"
                style={{ color: "red" }}
              >
                {validationResults.email}
              </p>
            )}
          </div>
        </div> */}

      

   
        <hr className="my-12" />

        <div className="mt-[3em] ">
          <div className="flex flex-col md:flex-row xl:gap-[14em] md:gap-[3em] ">
          <div>
          <label
            htmlFor="Logo"
            className=" font-semibold mt-5"
          >
            Brand
          </label>
          <p className="text-[14px] text-gray-600 hidden md:block">Update your business brand here</p>
          </div>
          
          <div className="xl:text-[14px]   font-light  xl:ml-[em] md:mt-[3px]">
          <p className="font-medium hidden md:block">Upload Brand Logo</p>
            <div className="flex  mt-[5px]">
              <div
                onClick={handleSelectFile}
                className="flex items-center justify-center px-[13px]  lg:w-[530px] py-[8px] lg:h-[120px] md:w-[300px] md:h-[120px] w-full h-[100px] rounded-[4px] bg-gray-50 border-gray-300 border border-dashed "
              >
                <p className="cursor-pointer">Upload document</p>
                <div className=" w-[1px] h-full mx-[9px] "></div>
                {/* <UploadIcon /> */}
                <input
                  className="hidden"
                  type="file"
                  ref={inputRef}
                  accept="image/jpeg,image/jpg,image/png"
                  onChange={handleUpload}
                />
              </div>
            </div>
            {file && (
              <div className="flex items-center text-lg mt-3">
                <span className="text-[#0500F9] mx-3  font-medium">
                  {shortenFileName(file)}
                </span>
                <a href="#close" onClick={() => setFile(undefined)}>
                  <CloseIcon color="red" />
                </a>
              </div>
            )}
          </div>
          </div>
        </div>

        {/* <div className="mt-[1em] ">
          <label
            htmlFor="color-input"
            className="text-sm text-gray-600 font-medium mt-5 ml-1"
          >
            Brand Color
            <p className="text-[13px] font-light   mt-[em]">
              Choose a color that best fit the brand
            </p>
          </label>
          <div className="mt-[-0.2em]">
            <input
              type="color"
              id="color-input"
              className="block w-10 h-10 rounded-md border-gray-300"
              value={formData.brandColor || "#044E97"}
              onChange={(e) => {
                const hexColor = e.target.value;
                setFormData((prevData) => ({
                  ...prevData,
                  brandColor: hexColor,
                }));
              }}
            />
          </div>
        </div> */}

        <hr className="mt-12" />

        <div className="xl:w-[300px] md:w-[300px]  pb-6" />
        <div className="flex justify-center items-center pb-6">
          <div className="w-full flex justify-center gap-[1em] mt-4 pb-6 xl:ml-[25em]">
            
           <button type="submit" className="px-10 py-3  bg-[#F2F4F7] text-gray-700 font-semibold rounded-md hidden md:flex"  >
              Cancel
            </button>
            <button
  type="submit"
  className="px-6 py-3 border border-[#0469C5] text-[#044E97] font-semibold rounded-md hidden md:flex items-center justify-center min-w-[140px]"
  disabled={isLoading}
>
  {isLoading ? (
  <div className="w-7 h-7 border-4 border-gray-200 border-t-[#044E97] rounded-full animate-spin"></div>
  ) : (
    "Save Changes"
  )}
</button>
            
            <div className="w-full md:hidden">
            <UI.Button
              type="submit"
              text="Save Changes"
              isLoading={isLoading}
              variant="secondary"
              size="full"
            />
            </div>
          </div>
        </div>
    </form>
    // </SidebarDrawer>
  );
};

export { EditProfile };
